import { render, staticRenderFns } from "./defra-units.vue?vue&type=template&id=66a133ec&scoped=true"
import script from "./defra-units.vue?vue&type=script&lang=js"
export * from "./defra-units.vue?vue&type=script&lang=js"
import style0 from "./defra-units.vue?vue&type=style&index=0&id=66a133ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a133ec",
  null
  
)

export default component.exports